export const stripHtmlAttributes = (html) => {
    if (!html) return '';
    let result = html;

    // Remove spans that only contain &nbsp; (Word/CMS formatting artifacts)
    result = result.replace(/<span[^>]*>\s*(?:&nbsp;| )\s*<\/span>/gi, ' ');

    // Unwrap all span and div tags, keeping their inner content
    result = result.replace(/<span[^>]*>/gi, '');
    result = result.replace(/<\/span>/gi, '');
    result = result.replace(/<div[^>]*>/gi, '');
    result = result.replace(/<\/div>/gi, '');

    // For anchor tags, preserve only href, target, and rel
    result = result.replace(/<a\b[^>]*>/gi, (match) => {
        const href = (match.match(/href="([^"]*)"/i) || [])[1];
        const target = (match.match(/target="([^"]*)"/i) || [])[1];
        const rel = (match.match(/rel="([^"]*)"/i) || [])[1];
        const attrs = [
            href ? `href="${href}"` : '',
            target ? `target="${target}"` : '',
            rel ? `rel="${rel}"` : '',
        ].filter(Boolean).join(' ');
        return attrs ? `<a ${attrs}>` : '<a>';
    });

    // For img tags, preserve only src and alt
    result = result.replace(/<img\b[^>]*>/gi, (match) => {
        const src = (match.match(/src="([^"]*)"/i) || [])[1];
        const alt = (match.match(/alt="([^"]*)"/i) || [])[1] || '';
        return src ? `<img src="${src}" alt="${alt}">` : '';
    });

    // Strip all attributes from remaining tags (a and img are already handled above)
    result = result.replace(/<(?!\/?(a|img)\b)([a-z][a-z0-9]*)\s+[^>]*>/gi, '<$2>');

    // Replace all non-breaking spaces with regular spaces
    result = result.replace(/&nbsp;/gi, ' ');

    // Collapse excess whitespace
    result = result.replace(/[ \t]{2,}/g, ' ');

    // Trim spaces immediately after opening tags and before closing tags
    result = result.replace(/(<[a-z][a-z0-9]*(?:\s[^>]*)?>) /gi, '$1');
    result = result.replace(/ (<\/[a-z][a-z0-9]*>)/gi, '$1');

    return result.trim();
};
